import { Routes } from '@angular/router';
import { PortfolioComponent } from '@portfolio/portfolio.component';

export const PortfolioRoutes: Routes = [
  {
    path: ':id',
    component: PortfolioComponent,
    data: { titleKey: 'routes.portfolio' },
  },
];
